export default __webpack_public_path__ + "static/media/promo-b.99922b1c.png";